import AppWelcomeScreenStore from "./AppWelcomeScreenStore";
import AppWelcomeScreenContainer from "./AppWelcomeScreenContainer";

export default AppWelcomeScreenStore(AppWelcomeScreenContainer)